const chosePackageProduct = () => {


    const productListBlock = document.querySelector('[data-block="product-list"]');

    try {
        productListBlock.addEventListener('click', (e)=>{
            let target = e.target;

            // открываем попап
            if((target.classList.contains('equipment-item') || target.closest('.equipment')) && !target.closest('.equipment_popup')) {

                // закрываем все попапы
                removeAllPopup();
                //END закрываем все попапы

                let popup = target.closest('.equipment').querySelector('[data-entity="basket-item-sku-block"]');

                if(popup) {
                    popup.classList.add('active');    
                    popup.classList.add('fade-in');    
                    
                    addEventListener('click', closePopup);
                }

                
            }

            // закрываем попап
            if(target.classList.contains('close-popup')) {
                
                let popup = target.closest('.control-wrap').querySelector('[data-entity="basket-item-sku-block"]');


                    popup.classList.remove('active');    
                    popup.classList.remove('fade-in'); 

                    removeEventListener('click', closePopup);
            }

            // подставляем выбранную информацию в контейнер
            if(target.closest('.equipment_popup') && target.closest('.equipment-item')) {
                // console.log(target.closest('.equipment-item'));

                // let infoBlock = target.closest('.control-wrap').querySelector('.equipment-item');

                // infoBlock.innerHTML = target.closest('.equipment-item').innerHTML;

                // поля из модалки
                let infoLine    = target.closest('.equipment-item');
                let titleLine   = infoLine.querySelector('.title .offer_num');
                let priceLine   = infoLine.querySelector('.current-price');

                // поля из товара
                let infoBlockNum    = target.closest('.product-card_horizontal').querySelector('.control-wrap .offer_size');
                let priceForOne     = target.closest('.product-card_horizontal').querySelector('.price-wrap .offer_price');

                infoBlockNum.textContent = titleLine.textContent;
                priceForOne.textContent = priceLine.textContent;

                removeAllPopup();
            }


        });

    } catch(e){}

    function closePopup(event) {
        let target = event.target;

        if(!target.closest('.equipment_popup') && !target.classList.contains('equipment-item') && !target.closest('.equipment')) {
            removeAllPopup();   
        }
    }

    function removeAllPopup() {
        let popupArr = document.querySelectorAll('.equipment_popup');
            if(popupArr[0]) {
                popupArr.forEach(item => {
                    item.classList.remove('active');    
                    item.classList.remove('fade-in'); 
                });
                
            }
    }

};

export default chosePackageProduct;
